// extracted by mini-css-extract-plugin
export default {"details":"ooZZi4Dfj9DfB96vmNBt","checkMark":"ofUNiY6guYgOJssQG4Aw","content":"dO5LSJCoYw3CXxLiHVn5","appointmentRow":"yEU9gXChs_Qshi6sVjuP"};